import { defineStore } from 'pinia'
import type { CareTeam } from '~/repository/types/care-team'
import { type IApiInstance } from '../plugins/api'

export type ITeamsState = {
  isLoaded: boolean
  teams: CareTeam[]
  flatTeams: any[]
}

export const useTeamsStore = defineStore('teams', {
  state: (): ITeamsState => {
    return {
      isLoaded: false,
      teams: [],
      flatTeams: [],
    }
  },
  getters: {
    getTeams: (state) => (id: string) => {
      return state.flatTeams
    },
    getTeamById: (state) => (id: string) => {
      return state.teams.find((t: any) => t.id === id)
    },
    getTeamByIds: (state) => (ids: string[]) => {
      return state.teams.filter((t: any) => ids.includes(t.id))
    },
    getTeamNamesByIds: (state) => (ids: any, role?: any) => {
      const teams = state.teams.filter((t: any) => ids.includes(t.id) && (!role || role === t.role))
      return teams.flatMap((t: any) => t.name)
    },
  },
  actions: {
    async load() {
      const api: IApiInstance = useNuxtApp().$api as IApiInstance

      this.teams = (await api.careTeams.get()) as CareTeam[]

      this.flatTeams = this.teams?.flatMap((t: any) => {
        t.text = t.name
        t.value = t.id
        return t
      })

      if (this.teams) {
        this.isLoaded = true
      }
    },
    /**
     * An action to clear the user data from the storage, should be used upon signing out the user.
     *
     * @param {object} context - VueX store context containing commit helper for mutations.
     */
    clear() {
      this.$reset()
    },
  },
})
